export function createPageWidthCalculator({ getActivePageWidth, getNormalPageWidth, }) {
    return function pageWidthCalculator(label, active) {
        return active ? getActivePageWidth(label) : getNormalPageWidth(label);
    };
}
